import React from 'react'

const LiveDataBar = ({ liveData, width, count }) => {
  const parentRef = React.useRef(null)
  const [isData, setIsData] = React.useState(null)
  const [tooltip, setTooltip] = React.useState({
    visible: false,
    x: 0,
    overflow: false
  })

  const updatePosition = (e) => {
    if (!parentRef.current) return
    const rect = parentRef.current.getBoundingClientRect()
    const x = e.clientX - rect.left

    const tooltipWidth = 300
    const margin = 8
    const maxX = rect.width - tooltipWidth / 2 - margin

    setTooltip((prev) => ({ ...prev, x, overflow: x > maxX }))
  }

  const handleMouseEnter = (e, data) => {
    updatePosition(e)
    setIsData(data)
    setTooltip((prev) => ({ ...prev, visible: true }))
  }

  const handleMouseLeave = () => {
    setIsData(null)
    setTooltip({ visible: false, x: 0 })
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '8px'
      }}
    >
      <div
        style={{
          fontSize: '12px'
        }}
      >
        <b>Note:</b> Hover on the chart to see more information
      </div>
      <div
        ref={parentRef}
        style={{
          width: '100%',
          position: 'relative',
          display: 'flex',
          maxWidth: `${width}px`,
          marginBottom: '16px'
        }}
      >
        {React.Children.toArray(
          liveData.map((data) => {
            const hourBlockWidth = Math.ceil(width / count)
            return (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  height: '50px',
                  width: `${hourBlockWidth}px`,
                  position: 'relative'
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    bottom: '-20px',
                    left: String(data.hour).length === 1 ? '-10px' : '-14px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}
                >
                  {data.hour}:00
                </div>
                <div
                  style={{
                    position: 'absolute',
                    bottom: '-4px',
                    left: 0,
                    fontSize: '12px',
                    fontWeight: 'bold',
                    height: '4px',
                    width: '1px',
                    backgroundColor: '#000'
                  }}
                ></div>
                <div
                  style={{
                    position: 'absolute',
                    left: 0,
                    fontSize: '12px',
                    fontWeight: 'bold',
                    height: '50px',
                    width: '0.5px',
                    backgroundColor: ' #fff'
                  }}
                ></div>
                {data.data.map((item) => {
                  const minuteBarWidth = hourBlockWidth / 60
                  return (
                    <div
                      onMouseEnter={(e) => handleMouseEnter(e, item)}
                      onMouseLeave={handleMouseLeave}
                      style={{
                        width: `${minuteBarWidth}px`,
                        backgroundColor: item.idleReasonColor,
                        cursor: 'pointer'
                      }}
                    ></div>
                  )
                })}
              </div>
            )
          })
        )}
        {tooltip.visible && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: tooltip.x,
              width: '1px',
              height: '100%',
              backgroundColor: 'white',
              pointerEvents: 'none',
              transform: 'translateX(-1px)',
              zIndex: 9
            }}
          />
        )}
        {tooltip.visible && isData && (
          <div
            style={{
              width: '300px',
              position: 'absolute',
              top: '50px',
              left: tooltip.overflow ? tooltip.x - 300 : tooltip.x,
              background: 'rgba(0, 0, 0, 0.7)',
              color: 'white',
              padding: '12px',
              borderRadius: '8px',
              fontSize: '14px',
              pointerEvents: 'none',
              zIndex: 10,
              whiteSpace: 'nowrap'
            }}
          >
            <div>Time: {isData.time}</div>
            {isData.missing ? (
              <div>No data available for this minute</div>
            ) : (
              <>
                <div>Reason: {isData.idleReason}</div>
                <div>
                  Status: {isData.machineStatus === 0 ? 'Running' : 'Idle'}
                </div>
                <div>Part name: {isData.partName}</div>
                <div>Part type: {isData.partType}</div>
                <div>Operator: {isData.operator}</div>
                <div>Supervisor: {isData.supervisor}</div>
                <div>Line Inspector: {isData.lineInspector}</div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default LiveDataBar
